import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildingsMissing_data_alerts = z.any()
export type TagsGetBuildingsMissing_data_alerts = z.infer<typeof tagsGetBuildingsMissing_data_alerts>

export const querystringGetBuildingsMissing_data_alerts = z.object({ "from": z.string().date(), "to": z.string().date() })
export type QuerystringGetBuildingsMissing_data_alerts = z.infer<typeof querystringGetBuildingsMissing_data_alerts>

export const responseGetBuildingsMissing_data_alerts = z.object({ "payload": z.array(z.object({ "collectionPointId": z.string(), "collectionPointName": z.string(), "buildingId": z.string(), "buildingName": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "customType": z.union([z.string(), z.null()]), "periods": z.array(z.object({ "from": z.string().date(), "to": z.string().date() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildingsMissing_data_alerts = z.infer<typeof responseGetBuildingsMissing_data_alerts>

interface IGetBuildingsMissing_data_alerts extends BaseMethodType {
  tags: TagsGetBuildingsMissing_data_alerts,
  querystring: QuerystringGetBuildingsMissing_data_alerts,
  response: ResponseGetBuildingsMissing_data_alerts
}
export const URL = '/buildings/missing-data-alerts'
export const validation = {
  get: {
    tags: tagsGetBuildingsMissing_data_alerts,
    querystring: querystringGetBuildingsMissing_data_alerts,
    response: responseGetBuildingsMissing_data_alerts
  }
}
export interface BuildingsMissing_data_alerts extends BaseRouteType {
  get: IGetBuildingsMissing_data_alerts
}